import { post, put, get } from "../../helpers/apihelpers";

export const CreateWorkFromHomeEmployeeOptionService=async(data)=>{
    try {
        const result = await post(`api/admin/work_from_home_employee_option/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateWorkFromHomeEmployeeOptionService=async(data,id)=>{
    try {
        const result = await put(`api/admin/work_from_home_employee_option/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetWorkFromHomeEmployeeOptionService = async ()=>{
  try {
    const result = await get(`api/admin/work_from_home_employee_option/get`);
    return result;
  } catch (err) {
    return err.response;
  }
}